import db from "../db";
import Constants from "../constants";
import * as Helpers from "../helpers";
import Vuex from "vuex";
import moment from "moment";

export default {
  methods: {
    inviaBusta(offerta) {
      db.setOfferta(
        offerta,
        false,
        true,
        offerta !== this.roundStep.min_offerta
      );
      this.stopBustaTimer && this.stopBustaTimer();
    },
    showNumpad() {
      db.emit("numpad", true);
    },
    hideNumpad() {
      db.emit("numpad", false);
    },
    bustaChiusaOffertaTime(uid) {
      return this.asta_round.offerte_ts && uid in this.asta_round.offerte_ts
        ? moment(this.asta_round.offerte_ts[uid]).format("HH:mm:ss") +
            '<span class="millis">.' +
            moment(this.asta_round.offerte_ts[uid]).format("SSS") +
            "</span>"
        : "";
    },
    apriBuste() {
      db.setStep({
        type: Constants.ROUND_STEP.BUSTE,
        min_offerta: this.roundStep.min_offerta
          ? this.roundStep.min_offerta
          : null,
      });
    },
    startBustaChiusaProcessing() {
      return db.setStep({
        type: Constants.ROUND_STEP.BUSTE,
        min_offerta:
          this.roundStep && this.roundStep.min_offerta
            ? this.roundStep.min_offerta
            : null,
        processing: true,
      });
    },
    getBustaChiusaEsito() {
      const offertaVincente = this.migliore_offerta.offerta;

      if (offertaVincente === Constants.OFFERTA.PASSO) {
        return {
          text: "Tutti hanno passato. Il calciatore verrà scartato",
          cb: () => {
            return this.startBustaChiusaProcessing().then(() => {
              db.emit("offerte");
            });
          },
        };
      }

      const offerteVincenti = _.sumBy(_.values(this.asta_round.offerte), (i) =>
        i === offertaVincente ? 1 : 0
      );

      if (offerteVincenti === 1) {
        return {
          text:
            "<b>" +
            this.squadra(this.migliore_offerta.vincitore).name +
            " </b> si è aggiudicato il calciatore.",
          cb: () => {
            let offerte = _.cloneDeep(this.asta_round.offerte);
            let offerteEdited = false;
            for (let sqid in offerte) {
              if (
                offerte[sqid] !== offertaVincente &&
                offerte[sqid] !== Constants.OFFERTA.PASSO
              ) {
                offerte[sqid] = Constants.OFFERTA.PASSO;
                offerteEdited = true;
              }
            }
            if (offerteEdited) {
              return this.startBustaChiusaProcessing().then(() =>
                db.setOfferte(offerte)
              );
            }
            return this.startBustaChiusaProcessing().then(() => {
              db.emit("offerte");
            });
          },
        };
      }

      if (offerteVincenti > 1) {
        let newRound = false;
        let offerte = this.asta_round.offerte;

        if (this.roundStep.min_offerta !== offertaVincente) {
          for (let sqid in offerte) {
            if (offerte[sqid] === offertaVincente) {
              if (this.squadra(sqid).max_offerta > offertaVincente) {
                newRound = true;
              }
              break;
            }
          }
        }

        return {
          text: newRound
            ? "Più di un vincitore. Si procede con un nuovo round tra i soli vincitori."
            : "Nessuno ha offerto di più: calciatore assegnato a <b>" +
              this.bustaChiusaOfferteOrdinate[0].squadraName +
              "</b> perché è stato il più rapido a fare l'offerta migliore",
          cb: newRound
            ? () => {
                let offerte = _.cloneDeep(this.asta_round.offerte);
                for (let sqid in offerte) {
                  if (offerte[sqid] === offertaVincente) {
                    offerte[sqid] = Constants.OFFERTA.INIT;
                  } else {
                    offerte[sqid] = Constants.OFFERTA.PASSO;
                  }
                }

                return db.setOfferte(offerte).then(() =>
                  db.setStep({
                    type: Constants.ROUND_STEP.OFFERTE,
                    min_offerta: offertaVincente,
                  })
                );
              }
            : () => {
                let offerte = _.cloneDeep(this.asta_round.offerte);
                for (let sqid in offerte) {
                  if (sqid !== this.bustaChiusaOfferteOrdinate[0].s) {
                    offerte[sqid] = Constants.OFFERTA.PASSO;
                  }
                }
                return this.startBustaChiusaProcessing().then(() =>
                  db.setOfferte(offerte)
                );
              },
        };
      }

      return {
        text: "",
        cb: () => {},
      };
    },
    eseguiBustaChiusaEsito() {
      return this.getBustaChiusaEsito().cb();
    },
    setPasso(confirm = false) {
      if (confirm) {
        Swal.fire({
          title: "Vuoi passare?",
          text: "Non potrai annullare l'operazione",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed == true) {
            db.setOfferta(Constants.OFFERTA.PASSO, false, true);
          }
        });
      } else {
        db.setOfferta(Constants.OFFERTA.PASSO, false, true);
        Swal.close();
      }
    },
  },
  computed: {
    canBustaChiusaAct() {
      return (
        this.mode_bustachiusa &&
        this.active &&
        this.calciatoreInAsta !== null &&
        this.calciatoreInAsta !== undefined &&
        this.running &&
        this.roundStep &&
        this.roundStep.type == Constants.ROUND_STEP.OFFERTE
      );
    },
    roundStep() {
      return this.asta_round.step;
    },
    bustaChiusaProcessing() {
      return Boolean(this.roundStep && this.roundStep.processing);
    },
    offerto() {
      return this.miaOfferta !== Constants.OFFERTA.INIT;
    },
    passato() {
      return this.miaOfferta === Constants.OFFERTA.PASSO;
    },
    bustaChiusaCannotJoinReason() {
      if (
        !this.asta_info ||
        !this.asta_info.lega ||
        !this.squadra(this.user_uid) ||
        this.calciatoreInAsta === null ||
        this.calciatoreInAsta === undefined
      ) {
        return null;
      }

      const calciatore = this.calciatore(this.calciatoreInAsta);
      const creditiMin =
        this.roundStep && this.roundStep.min_offerta
          ? parseFloat(this.roundStep.min_offerta)
          : Helpers.minOfferta(this.asta_settings.base_asta, calciatore);

      return Helpers.canJoinRoundWithReason(
        this.asta_info.lega,
        this.squadra(this.user_uid),
        calciatore,
        creditiMin
      ).reason;
    },
    bustaChiusaPassoText() {
      return this.bustaChiusaCannotJoinReason || "Hai passato";
    },
    showBustaChiusaAutoConfirmHint() {
      return (
        this.canBustaChiusaAct &&
        !this.offerto &&
        this.roundStep.min_offerta
      );
    },
    bustaChiusaAutoConfirmHint() {
      return (
        "Alla scadenza del countdown verrà confermata automaticamente l'offerta precedente (" +
        this.roundStep.min_offerta +
        ")."
      );
    },
    miaOfferta() {
      return this.asta_round.offerte && this.user_uid in this.asta_round.offerte
        ? this.asta_round.offerte[this.user_uid]
        : Constants.OFFERTA.INIT;
    },
    offerteCompletate() {
      return Helpers.offerteCompletate(this.asta_round.offerte);
    },
    bustaChiusaOfferteOrdinate() {
      return _.orderBy(
        _.map(this.asta_round.offerte, (value, key) => {
          return {
            s: key,
            squadraName: this.squadra(key).name,
            o: value,
            ts:
              this.asta_round.offerte_ts && key in this.asta_round.offerte_ts
                ? this.asta_round.offerte_ts[key]
                : -1,
          };
        }),
        ["o", "ts"],
        ["desc", "asc"]
      );
    },
    active() {
      return this.squadra(this.user_uid) && this.squadra(this.user_uid).active;
    },
    ruolo_abc() {
      if (this.calciatoreInAsta != null) {
        return Constants.RUOLI_NEW[
          this.calciatori[this.calciatoreInAsta].ID_Ruolo
        ].abc;
      }
      return null;
    },
    ...Vuex.mapGetters(["migliore_offerta", "myPlan"]),
  },
};
